import React, { useEffect, useState } from 'react';
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { Link } from "react-router-dom";
import { ChevronRight, ChevronLeft, Check } from 'lucide-react';
import './Jodhpuri.css'
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { LuSettings2 } from "react-icons/lu";
import { FaX } from "react-icons/fa6";
import { useLocation, useNavigate } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa6";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
const Jodhpuri = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const selectedStyle = location.state?.selectedStyle;
  const isFromSearch = location.state?.isFromSearch || false;
  const [isLoading, setIsLoading] = useState(true);
  const [breadcrumbText, setBreadcrumbText] = useState('Search');
  useEffect(() => {
    if (!isLoading) {
      // If it's from search, display "Search"
      if (isFromSearch) {
        setBreadcrumbText("Search");
      } else {
        // If not from search, display the selectedStyle or "All Products" if none
        setBreadcrumbText(selectedStyle || "All Products");
      }
    }
  }, [isLoading, isFromSearch, selectedStyle]);


  // When component mounts, set isLoading to false
  useEffect(() => {
    setIsLoading(false);
  }, []); // This
  console.log(selectedStyle);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [imageIndexes, setImageIndexes] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedPriceRange, setSelectedPriceRange] = useState('');

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [dateError, setDateError] = useState('');
  const [calculatedDays, setCalculatedDays] = useState(null);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(10000);
  const [sortOption, setSortOption] = useState('Featured');

  const durations = [1, 4, 6, 8, 10, 12];
  const [selectedDuration, setSelectedDuration] = useState(durations[0]);
  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  // Effect to set the initial delivery date to today when component mounts
  useEffect(() => {
    const today = getTodayDate();
    setDeliveryDate(today);

    // Calculate initial return date based on default duration
    const initialReturnDate = calculateReturnDate(today, durations[0]);
    setReturnDate(initialReturnDate);
  }, []);

  const calculateReturnDate = (deliveryDate, duration) => {
    if (!deliveryDate || !duration) return '';

    const delivery = new Date(deliveryDate);
    const return_date = new Date(delivery);
    // Add selected duration plus one extra day
    if (duration === 1) {
      return_date.setDate(delivery.getDate() + parseInt(duration) + 1);
    } else {
      return_date.setDate(delivery.getDate() + parseInt(duration) - 1);
    }

    return return_date.toISOString().split('T')[0];
  };

  const handleDeliveryDateChange = (date) => {
    setDeliveryDate(date);
    if (selectedDuration) {
      const newReturnDate = calculateReturnDate(date, selectedDuration);
      setReturnDate(newReturnDate);
      validateDates();
    }
  };

  const handleDurationChange = (duration) => {
    setSelectedDuration(duration);
    if (deliveryDate) {
      const newReturnDate = calculateReturnDate(deliveryDate, duration);
      setReturnDate(newReturnDate);
      validateDates();
    }
  };

  const calculateDateDifference = (delivery, return_date) => {
    if (!delivery || !return_date) return null;

    const deliveryTime = new Date(delivery);
    const returnTime = new Date(return_date);

    // Reset hours to ensure we're comparing full days
    deliveryTime.setHours(0, 0, 0, 0);
    returnTime.setHours(0, 0, 0, 0);

    const differenceInTime = returnTime.getTime() - deliveryTime.getTime();
    const differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));

    // Subtract 1 from the difference to match the selected duration
    if ((differenceInDays - 1) !== parseInt(selectedDuration)) {
      setDateError('Return date must match the selected duration plus one day');
      return null;
    }

    setDateError('');
    return differenceInDays - 1; // Return the actual rental duration
  };

  const validateDates = () => {
    if (deliveryDate && returnDate && selectedDuration) {
      const days = calculateDateDifference(deliveryDate, returnDate);
      setCalculatedDays(days);
      return days;
    }
    return null;
  };
  // Filter products based on the selected style
  useEffect(() => {
    if (selectedStyle) {
      const filtered = products.filter((product) =>
        product.selectedStyles.some((style) =>
          style.selectedStyles.includes(selectedStyle)
        )
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [selectedStyle, products]);

  useEffect(() => {
    if (deliveryDate && returnDate) {
      validateDates();
    }
  }, [deliveryDate, returnDate]);
  // Structured color options with value, label, and hex code
  const colorOptions = [
    { value: "blue", hex: "#0000FF", count: 2708 },
    { value: "green", hex: "#008000", count: 2585 },
    { value: "pink", hex: "#FFC0CB", count: 2324 },
    { value: "black", hex: "#000000", count: 1864 },
    { value: "yellow", hex: "#FFFF00", count: 1386 },
    { value: "navy blue", hex: "#000080", count: 1288 },
    { value: "red", hex: "#FF0000", count: 1180 },
    { value: "purple", hex: "#800080", count: 1020 },
    { value: "orange", hex: "#FFA500", count: 980 },
    { value: "white", hex: "#FFFFFF", count: 905 },
    { value: "gray", hex: "#808080", count: 880 },
    { value: "brown", hex: "#A52A2A", count: 750 },
    { value: "cyan", hex: "#00FFFF", count: 720 },
    { value: "magenta", hex: "#FF00FF", count: 690 },
    { value: "lime", hex: "#00FF00", count: 660 },
    { value: "maroon", hex: "#800000", count: 640 },
    { value: "olive", hex: "#808000", count: 620 },
    { value: "teal", hex: "#008080", count: 600 },
    { value: "indigo", hex: "#4B0082", count: 580 },
    { value: "violet", hex: "#EE82EE", count: 560 },
    { value: "turquoise", hex: "#40E0D0", count: 540 },
    { value: "gold", hex: "#FFD700", count: 520 },
    { value: "silver", hex: "#C0C0C0", count: 500 },
    { value: "peach", hex: "#FFDAB9", count: 480 },
    { value: "mint green", hex: "#98FF98", count: 460 },
  ];

  const fetchProducts = async () => {
    try {
      const response = await fetch("/api/all/products");
      if (!response.ok) throw new Error("Failed to fetch products");
      const data = await response.json();
      setProducts(data);
      setFilteredProducts(data);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleSort = (option) => {
    setSortOption(option);

    // Create a copy of the array to sort
    let sortedProducts = [...filteredProducts];

    // Ensure salePrice is converted to a number correctly by removing any non-numeric characters
    sortedProducts = sortedProducts.map((product) => ({
      ...product,
      // Remove currency symbols, commas, spaces and convert to number
      salePrice: Number(String(product.salePrice).replace(/[^0-9.-]+/g, ''))
    }));

    // Sorting logic
    switch (option) {
      case "Price, Low to High":
        sortedProducts.sort((a, b) => {
          const priceA = Number(String(a.salePrice).replace(/[^0-9.-]+/g, ''));
          const priceB = Number(String(b.salePrice).replace(/[^0-9.-]+/g, ''));
          return priceA - priceB;
        });
        break;
      case "Price, High to Low":
        sortedProducts.sort((a, b) => {
          const priceA = Number(String(a.salePrice).replace(/[^0-9.-]+/g, ''));
          const priceB = Number(String(b.salePrice).replace(/[^0-9.-]+/g, ''));
          return priceB - priceA;
        });
        break;
      case "Alphabetically, A-Z":
        sortedProducts.sort((a, b) => a.productName.localeCompare(b.productName));
        break;
      case "Alphabetically, Z-A":
        sortedProducts.sort((a, b) => b.productName.localeCompare(a.productName));
        break;
      case "Featured":
        sortedProducts = [...products]; // Reset to original order
        break;
      case "Best Selling":
        sortedProducts = [...products]; // You can implement custom logic for best selling
        break;
      default:
        sortedProducts = [...products];
    }

    // Update state with sorted products
    setFilteredProducts(sortedProducts);
  };




  const handleImageNavigation = (productId, direction) => {
    setImageIndexes((prev) => {
      const currentIndex = prev[productId] || 0;
      const product = products.find(p => p._id === productId);
      const totalImages = product.images.length;
      let nextIndex;

      if (direction === 'next') {
        nextIndex = (currentIndex + 1) % totalImages;
      } else {
        nextIndex = (currentIndex - 1 + totalImages) % totalImages;
      }

      return { ...prev, [productId]: nextIndex };
    });
  };

  const priceRanges = [
    { label: '₹0 - ₹2000', min: 0, max: 2000 },
    { label: '₹2001 - ₹3000', min: 2001, max: 3000 },
    { label: '₹3001 - ₹4000', min: 3001, max: 4000 },
    { label: '₹4001 - ₹5000', min: 4001, max: 5000 },
    { label: '₹5001 - ₹10,000', min: 5001, max: 10000 },

  ];

  //   const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const sizes = {
    XS: "32",
    S: "34",
    M: "36",
    L: "38",
    XL: "40",
    '2XL': "42",
    '3XL': "44",
    '4XL': "46",
  };


  // Normalize color to handle case-insensitive matching
  const normalizeColor = (color) => {
    if (!color) return '';
    const colorLower = color.toLowerCase().trim();
    const matchedColor = colorOptions.find(option =>
      colorLower === option.value.toLowerCase() ||
      colorLower.includes(option.value.toLowerCase())
    );
    return matchedColor ? matchedColor.value : colorLower;
  };

  const categories = [...new Set(products.flatMap(product =>
    product.categories.map(cat => cat.name)
  ))];

  // const getCategoriesBasedOnStyle = () => {
  //   if (!selectedStyle) {
  //     // When no style is selected, get all unique categories while preserving all products
  //     const allCategories = products.flatMap((product) => product.categories);
  //     // Use Set to get unique category names, then find the first category object for each name
  //     const uniqueCategoryNames = [...new Set(allCategories.map(cat => cat.name))];
  //     return uniqueCategoryNames.map(name =>
  //       allCategories.find(cat => cat.name === name)
  //     );
  //   }

  //   // Get products that match the selected style
  //   const filteredProducts = products.filter((product) =>
  //     product.selectedStyles.some((style) =>
  //       style.selectedStyles.includes(selectedStyle)
  //     )
  //   );

  //   // Get unique categories from filtered products
  //   const filteredCategories = filteredProducts.flatMap((product) => product.categories);
  //   const uniqueCategoryNames = [...new Set(filteredCategories.map(cat => cat.name))];
  //   return uniqueCategoryNames.map(name =>
  //     filteredCategories.find(cat => cat.name === name)
  //   );
  // };
  const getCategoriesBasedOnStyle = () => {
    // If no style is selected, get all unique categories across all products
    const allCategories = products.flatMap((product) => product.categories);
    const uniqueCategoryNames = [...new Set(allCategories.map(cat => cat.name))];

    return uniqueCategoryNames.map(name =>
      allCategories.find(cat => cat.name === name)
    );
  };

  // useEffect(() => {
  //   let filtered = [...products];


  //   if (selectedStyle) {
  //     filtered = filtered.filter((product) =>
  //       product.selectedStyles.some((style) =>
  //         style.selectedStyles.includes(selectedStyle)
  //       )
  //     );
  //   }

  //   // Then filter by selected categories if any are selected
  //   if (selectedCategories.length > 0) {
  //     filtered = filtered.filter((product) =>
  //       product.categories.some((cat) => selectedCategories.includes(cat.name))
  //     );
  //   }
  //   // Color filter
  //   if (selectedColors.length > 0) {
  //     filtered = filtered.filter(product => {
  //       const normalizedProductColor = normalizeColor(product.color);
  //       return selectedColors.includes(normalizedProductColor);
  //     });
  //   }

  //   // Price range filter
  //   if (selectedPriceRange) {
  //     const range = priceRanges.find(range => range.label === selectedPriceRange);
  //     filtered = filtered.filter(product =>
  //       product.salePrice >= range.min && product.salePrice <= range.max
  //     );
  //   }

  //   // Size filter
  //   console.log("seleectd size", selectedSizes)


  //   if (selectedSizes.length > 0) {
  //     filtered = filtered.filter(product => {
  //       console.log("Product sizes:", product.size); // Debugging
  //       const productSizesWithQuantity = product.size.filter(sizeObj => sizeObj.quantity > 0); // Only sizes with quantity > 0
  //       console.log("Sizes with quantity > 0:", productSizesWithQuantity); // Debugging

  //       // Extract sizes from valid size objects
  //       const productSizes = productSizesWithQuantity.map(sizeObj => sizeObj.size);
  //       console.log("Filtered product sizes:", productSizes); // Debugging
  //       console.log("Selected sizes:", selectedSizes); // Debugging

  //       // Ensure comparison works regardless of type or formatting
  //       return selectedSizes.some(selectedSize =>
  //         productSizes.includes(selectedSize)
  //       );
  //     });
  //   }

  //   // Date and duration filter
  //   if (deliveryDate && returnDate) {
  //     filtered = filtered.filter(product =>
  //       product.deliveryDuration.some(duration => duration >= selectedDuration)
  //     );
  //   }

  //   setFilteredProducts(filtered);
  // }, [
  //   selectedCategories,
  //   selectedColors,
  //   selectedPriceRange,
  //   selectedSizes,
  //   deliveryDate,
  //   returnDate,
  //   selectedDuration,
  //   products,
  //   selectedStyle,
  // ]);
  useEffect(() => {
    let filtered = [...products]; // Start with all products

    // Apply Selected Style Filter (if available)
    if (selectedStyle) {
      // Filter first based on selectedStyle
      filtered = filtered.filter((product) => {
        // Check if selectedStyle matches product's selectedStyles or other attributes
        const matchesStyle = product.selectedStyles.some(styleCategory =>
          styleCategory.selectedStyles.some(style =>
            style.toLowerCase().includes(selectedStyle.toLowerCase()) // Case-insensitive match
          )
        );

        // Also check if the selectedStyle matches productName, category, or color
        const matchesOtherAttributes = [
          product.productName,
          product.category,
          product.color,
        ].some(attr =>
          typeof attr === "string" && attr.toLowerCase().includes(selectedStyle.toLowerCase())
        );

        return matchesStyle || matchesOtherAttributes; // Keep product if either matches
      });

      console.log("Filtered by selectedStyle:", filtered); // Log after selectedStyle filter
    }

    // Apply Category Filter (if any selectedCategories exist)
    if (selectedCategories.length > 0) {
      filtered = filtered.filter((product) =>
        product.categories.some((cat) => selectedCategories.includes(cat.name))
      );
      console.log('Filtered by categories:', filtered); // Log after category filter
    }

    // Apply Color Filter (if any selectedColors exist)
    if (selectedColors.length > 0) {
      filtered = filtered.filter(product => {
        const normalizedProductColor = normalizeColor(product.color);
        return selectedColors.includes(normalizedProductColor);
      });
      console.log('Filtered by color:', filtered); // Log after color filter
    }

    // Apply Price Range Filter (if any selectedPriceRange exists)
    if (selectedPriceRange) {
      const range = priceRanges.find(range => range.label === selectedPriceRange);
      filtered = filtered.filter(product =>
        product.salePrice >= range.min && product.salePrice <= range.max
      );
      console.log('Filtered by price range:', filtered); // Log after price range filter
    }

    // Apply Size Filter (if any selectedSizes exist)
    if (selectedSizes.length > 0) {
      filtered = filtered.filter(product => {
        const productSizesWithQuantity = product.size.filter(sizeObj => sizeObj.quantity > 0);
        const productSizes = productSizesWithQuantity.map(sizeObj => sizeObj.size);
        return selectedSizes.some(selectedSize =>
          productSizes.includes(selectedSize)
        );
      });
      console.log('Filtered by size:', filtered); // Log after size filter
    }

    // Apply Delivery Date & Duration Filter (if deliveryDate and returnDate are provided)
    if (deliveryDate && returnDate) {
      filtered = filtered.filter(product =>
        product.deliveryDuration.some(duration => duration >= selectedDuration)
      );
      console.log('Filtered by delivery date and duration:', filtered); // Log after delivery filter
    }

    // After all filtering, log the final filtered products
    console.log('Final Filtered Products:', filtered);

    // Set the filtered products state
    setFilteredProducts(filtered);

  }, [
    selectedCategories,
    selectedColors,
    selectedPriceRange,
    selectedSizes,
    deliveryDate,
    returnDate,
    selectedDuration,
    products, // Re-run when products change
    selectedStyle, // Re-run when selectedStyle changes
  ]);


  const handleCategoryChange = (categoryName) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryName)
        ? prev.filter((cat) => cat !== categoryName)
        : [...prev, categoryName]
    );
  };


  const handleApply = async () => {
    setIsLoading(true);
    try {
      // Wait for 1 second to show loading state
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Reload the page
      window.location.reload();
    } catch (error) {
      console.error('Error:', error);
      // setIsLoading(false);
    }
  };

  const handleRent = (productId) => {
    console.log("Navigating with productId:", productId); // Debugging step
    navigate('/productpreview', { state: { productId } }); // Pass productId to preview page
  };

  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [productsPerPage, setProductsPerPage] = useState(8); // Number of products per page

  // Calculate the index of the first and last product on the current page
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;

  // Get the products to display on the current page
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  // Handle page change (next and previous)
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle change in items per page
  const handleItemsPerPageChange = (event) => {
    setProductsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page whenever items per page change
  };
  // const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Set a timer for 10 seconds to stop the loading state
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Cleanup the timer
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div >
        <div class="tf-page-title">
          <div >
            <div class="row">
              <div class="col-12">

                <div className="heading text-center">
                  <h4 className="breadcrumbtitle">{breadcrumbText}</h4>
                  <div className="breadcrumb">
                    <Link to="/" style={{ color: "black" }}>
                      <h6>Home</h6>
                    </Link>
                    <AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                    <h6>{breadcrumbText}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loader" style={{ justifySelf: "center", margin: "10vh" }}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );
  };
  return (
    <>
      <div class="tf-page-title">
        <div >
          <div class="row">
            <div class="col-12">

              <div className="heading text-center">
                <h4 className="breadcrumbtitle">{breadcrumbText}</h4>
                <div className="breadcrumb">
                  <Link to="/" style={{ color: "black" }}>
                    <h6>Home</h6>
                  </Link>
                  <AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                  <h6>{breadcrumbText}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="flat-spacing-1" style={{ padding: '0' }}>
        <div class="container">
          {/* <!-- card products HERE --> */}
          <div class="tf-row-flex mt-3">
            <div class="tf-shop-sidebar wrap-sidebar-mobile">
              {/* PRODUCT CATEGORIES */}
              <div class="widget-facet ">
                <div
                  className="facet-title"
                  data-bs-target="#categories"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="categories"
                >
                  <span>Product categories</span>
                </div>
                {/* <span>Categories</span> */}
                <div id="categories" className="collapse show" style={{ marginBottom: "1vh" }}>

                  <ul className="space-y-2">
                    {getCategoriesBasedOnStyle().map((category) => (
                      <li key={category._id} className="flex  gap-2">
                        <input
                          type="checkbox"
                          id={`category-${category._id}`}
                          checked={selectedCategories.includes(category.name)}
                          onChange={() => handleCategoryChange(category.name)}
                          className="hidden" // Hide checkbox
                        />
                        <label
                          htmlFor={`category-${category._id}`}
                          className="label-style"
                        >
                          {category.name}
                        </label>
                      </li>
                    ))}
                  </ul>

                </div>


              </div>
              <div className="widget-facet">
                <div
                  className="facet-title"
                  data-bs-target="#size"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="categories"
                >
                  <span>Size</span>
                </div>

                <div id='size' className="tf-pagination-list tf-pagination-btn collapse show" style={{ marginBottom: "1vh" }}>
                  <div className="tf-pagination-list tf-pagination-btn">
                    {Object.entries(sizes).map(([sizeLabel, sizeValue]) => (
                      <button
                        key={sizeLabel}
                        className={`pagination-link ${selectedSizes.includes(sizeValue)
                          ? 'text-success'
                          : 'animate-hover-btn'
                          }`}
                        onClick={() => {
                          setSelectedSizes(prev =>
                            prev.includes(sizeValue)
                              ? prev.filter(s => s !== sizeValue)
                              : [...prev, sizeValue]
                          );
                        }}
                      >
                        {sizeLabel}
                      </button>
                    ))}
                  </div>

                </div></div>
              {/* COLORS */}
              <div className="widget-facet">
                <div
                  className="facet-title"
                  data-bs-target="#color"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="color"
                >
                  <span>Color</span>
                  <span className="icon icon-arrow-up"></span>
                </div>
                <div id="color" className="collapse show">
                  <div className="color-palette flex flex-wrap ">
                    {colorOptions.map((color) => (
                      <div
                        key={color.value}
                        className={`color-box w-10 h-10 rounded-full cursor-pointer border ${selectedColors.includes(color.value)
                          ? "border-blue-500"
                          : "border-gray-300"
                          }`}
                        style={{ backgroundColor: color.hex }}
                        onClick={() => {
                          setSelectedColors((prev) =>
                            prev.includes(color.value)
                              ? prev.filter((c) => c !== color.value)
                              : [...prev, color.value]
                          );
                        }}
                      >
                        {selectedColors.includes(color.value) && (
                          <div className="flex items-center justify-center w-full h-full">
                            <Check className="w-4 h-4 text-white" />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div action="#" id="facet-filter-form" class="facet-filter-form">

                {/* PRICE RANGE */}
                <div className="widget-facet wrap-price mb-8">
                  <div
                    className="facet-title"
                    data-bs-target="#price"
                    data-bs-toggle="collapse"
                    aria-expanded="true"
                    aria-controls="categories"
                  >
                    <span>Price Range</span>
                    <span className="icon icon-arrow-up"></span>
                  </div>

                  {/* Radio Buttons for Predefined Ranges */}
                  <div className="space-y-3 mb-6 collapse show" id="price" >
                    {priceRanges.map((range) => (
                      <label
                        key={range.label}
                        className="flex items-center p-2 hover:bg-gray-50 rounded-lg cursor-pointer"
                      >
                        <input
                          type="radio"
                          // React controls all "priceRange" radios
                          className="w-5 h-5 text-blue-600"
                          onChange={() => {
                            setSelectedPriceRange(range.label);
                            setMinPrice(range.min);
                            setMaxPrice(range.max);
                          }}
                          checked={selectedPriceRange === range.label} // React-managed checked state
                        />
                        <span className="ml-3 text-gray-700 " style={{ marginLeft: '10px' }}>{range.label}</span>
                      </label>
                    ))}
                  </div>


                </div>


                <div className="widget-facet">
                  <div
                    className="facet-title"
                    data-bs-target="#duration"
                    data-bs-toggle="collapse"
                    aria-expanded="true"
                    aria-controls="brand"
                  >
                    <span>Duration (Days)</span>
                    <span className="icon icon-arrow-up"></span>
                  </div>

                  <div className="tf-pagination-list tf-pagination-btn collapse show" id="duration">
                    {durations.map((day) => (
                      <button
                        key={day}
                        style={{ fontWeight: "800" }}
                        className={`pagination-link ${selectedDuration === day
                          ? 'text-success'
                          : 'animate-hover-btn'
                          }`}
                        onClick={() => handleDurationChange(day)}
                      >
                        {day}
                      </button>
                    ))}

                    <ul className="tf-filter-group current-scrollbar mb_36">
                      <label htmlFor="brand-1" className="label" style={{ marginTop: '10px' }}>
                        <span>Delivery On</span>
                      </label>
                      <li className="list-item d-flex gap-12 align-items-center " style={{ marginTop: '10px' }}>

                        <input
                          type="date"
                          name="brand"
                          className="tf-check"
                          style={{ width: '100%', height: '40px', fontFamily: "Raleway, serif" }}
                          id="brand-1"
                          value={deliveryDate}
                          onChange={(e) => handleDeliveryDateChange(e.target.value)}
                          min={new Date().toISOString().split('T')[0]}
                        />

                      </li>
                      <label htmlFor="brand-2" className="label" style={{ marginTop: '10px' }}>
                        <span>Return On</span>
                      </label>
                      <li className="list-item d-flex gap-12 align-items-center">

                        <input
                          type="date"
                          name="brand"
                          style={{ width: '100%', height: '40px', fontFamily: "Raleway, serif" }}
                          className="tf-check"
                          id="brand-2"
                          value={returnDate}
                          readOnly
                          min={deliveryDate || new Date().toISOString().split('T')[0]}
                        />

                      </li>

                    </ul>
                  </div>
                </div>

                <button
                  className="tf-btn w-100 radius-3 pbtn-bg animate-hover-btn justify-content-center"
                  onClick={handleApply}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="d-flex align-items-center gap-2 justify-content-center">
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      Please wait...
                    </span>
                  ) : (
                    'APPLY'
                  )}
                </button>

                <button
                  onClick={() => {
                    setSelectedCategories([]);
                    setSelectedSizes([]);
                    setSelectedColors([]);
                    setSelectedPriceRange('');
                    setSelectedDuration('');
                    setFilteredProducts(products);
                  }}
                  class="tf-btn w-100 radius-3 pbtn-bg animate-hover-btn justify-content-center mt-3"
                >
                  CLEAR ALL
                </button>



              </div>
            </div>

            <div class="tf-shop-content wrapper-control-shop">


              <div style={{ fontSize: "16px" }}><b>{filteredProducts.length} Products</b> In {selectedStyle ? selectedStyle : "All Products"}</div>
              <div className='filtersection'>

                <div className=" sortdrop">
                  <div
                    className="btn-select"
                    onClick={() => document.getElementById('sort-dropdown').classList.toggle('show')}
                  >
                    <span className="text-sort-value">{sortOption}</span>
                    <FaAngleDown />
                  </div>
                  <div className="dropdown-menu " id="sort-dropdown">
                    {[
                      'Featured',
                      'Best Selling',
                      'Alphabetically, A-Z',
                      'Alphabetically, Z-A',
                      'Price, Low to High',
                      'Price, High to Low'
                    ].map((option) => (
                      <div
                        key={option}
                        className={`select-item ${sortOption === option ? 'active' : ''}`}
                        onClick={() => {
                          handleSort(option);
                          document.getElementById('sort-dropdown').classList.remove('show');
                        }}
                      >
                        <span className="text-value-item" style={{ margin: "5px" }}>{option}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div class="">
                  <a href="#filterShop" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
                    <button className='mobfilter'>
                      <LuSettings2 />
                      <span class="fw-5">Filters</span>
                    </button>
                  </a>

                </div>


              </div>

              <div className="selected-filters-wrap d-flex selectedfilters">
                <div className="selected-filters flex flex-wrap gap-4">

                  {selectedCategories.length > 0 && selectedCategories.map((category) => (
                    <div key={category} className="selected-filter-item">
                      <span className="filter-label">Category:</span>
                      <span className="filter-value">{category}</span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setSelectedCategories(prev => prev.filter(c => c !== category)); // Removes the specific category
                          setFilteredProducts(products); // Optionally adjust the filtered products
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  ))}

                  {/* Selected Sizes - Display each selected size in a separate box */}
                  {selectedSizes.length > 0 && selectedSizes.map((size) => (
                    <div key={size} className="selected-filter-item">
                      <span className="filter-label">Size:</span>
                      <span className="filter-value">{size}</span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setSelectedSizes(prev => prev.filter(s => s !== size)); // Removes the specific size
                          setFilteredProducts(products);
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  ))}

                  {/* Selected Colors */}
                  {selectedColors.length > 0 && selectedColors.map((color) => (
                    <div key={color} className="selected-filter-item color-filter-item">
                      <span className="filter-label">Color:</span>
                      <span
                        className="filter-value"
                        style={{ backgroundColor: color, padding: '4px 8px', width: '20px', height: '20px', borderRadius: '24px' }}
                      >
                      </span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setSelectedColors(prev => prev.filter(c => c !== color)); // Removes the specific color
                          setFilteredProducts(products);
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  ))}

                  {/* Selected Price Range */}
                  {selectedPriceRange && (
                    <div className="selected-filter-item">
                      <span className="filter-label">Price:</span>
                      <span className="filter-value">{selectedPriceRange}</span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setSelectedPriceRange(''); // Clears the selected price range
                          setFilteredProducts(products);
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  )}

                  {/* Selected Duration */}
                  {/* {selectedDuration && (
                    <div className="selected-filter-item">
                      <span className="filter-label">Duration:</span>
                      <span className="filter-value">{selectedDuration} days</span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setSelectedDuration(''); // Clears the selected duration
                          setFilteredProducts(products);
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  )} */}

                  {/* Delivery and Return Date */}
                  {/* {deliveryDate && returnDate && (
                    <div className="selected-filter-item">
                      <span className="filter-value">{deliveryDate}{' / '}</span>
                      <span className="filter-value">{returnDate}</span>
                      <button
                        className="cancel-filter-btn"
                        onClick={() => {
                          setDeliveryDate(''); // Clears the delivery date
                          setReturnDate(''); // Clears the return date
                          setFilteredProducts(products);
                        }}
                      >
                        <FaX />
                      </button>
                    </div>
                  )} */}
                </div>

              </div>

              {isLoading ? (
                <div class="loader">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              ) : (


                <div className="grid-layout wrapper-shop" data-grid="grid-2">

                  {currentProducts.map((product) => (
                    <div
                      className="card-product"
                      data-price={product.salePrice}
                      data-color="orange black white"
                      key={product._id}
                    >
                      {product.images.length > 0 && (
                        <div>
                          <div className="card-product-wrapper">
                            <a
                              href=""
                              onClick={() => handleRent(product._id)}
                              className="product-img"
                            >
                              <img
                                className="lazyload default-img"
                                data-src={`${product.images[imageIndexes[product._id] || 0].url.trim()}`}
                                src={`${product.images[imageIndexes[product._id] || 0].url.trim()}`}

                                alt={product.productName}
                              />
                              <img
                                className="lazyload hover-img"
                                data-src={`${product.images[imageIndexes[product._id] || 0].url.trim()}`}
                                src={`${product.images[imageIndexes[product._id] || 0].url.trim()}`}
                                alt={product.productName}
                              />

                            </a>
                            <div className="on-sale-wrap text-end">
                              <div className="on-sale-item">{product.discount}%</div>
                            </div>
                          </div>
                          <div className="card-product-info" style={{ textAlign: "center" }}>
                            <a href="" className="title link mb-2" style={{ color: "black", fontSize: "18px", fontWeight: "600" }}>
                              {product.productName}
                            </a>
                            <div className="display-flex justify-content-between mb-2 ">
                              <span className="price" style={{ color: "#0b3e27", marginRight: "2%" }}>
                                <MdOutlineCurrencyRupee />
                                {product.salePrice}
                              </span>
                              <span
                                className="price"
                                style={{ textDecoration: "line-through", color: "red" }}
                              >
                                <MdOutlineCurrencyRupee />
                                {product.originalPrice}
                              </span>
                              <span style={{ fontWeight: "bold", marginLeft: "6px" }}>MRP</span>
                            </div>
                            <div className="display-flex justify-content-between mb-2">
                              {product.categories.map((category) => (
                                <span key={category._id} className="price">
                                  {category.name.toUpperCase()}
                                </span>
                              ))}
                            </div>
                            <div className="display-flex justify-content-between mb-2">
                              <button
                                onClick={() => handleRent(product._id)}
                                style={{ color: "white" }}
                                className="tf-btn w-50 radius-3 pbtn-bg animate-hover-btn justify-content-center probtntopre"
                              >
                                RENT ROYALTY
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {filteredProducts.length === 0 && (
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <img src="./images/collections/noproduct.png" className="w-50 h-50 mb-4" alt="No products found" />
                  <button
                    onClick={() => {
                      setSelectedCategories([]);
                      setSelectedSizes([]);
                      setSelectedColors([]);
                      setSelectedPriceRange('');
                      setSelectedDuration('');
                      setFilteredProducts(products);
                    }}
                    class="tf-btn w-40 radius-3 btn-fill animate-hover-btn justify-content-center"
                  >
                    Clear All
                  </button>
                </div>
              )}


            </div>
          </div>
        </div>
      </section>
      {/* Pagination Controls */}
      <div className='pagination'>
        {/* Items per page selector */}
        <div className="items-per-page">
          <label htmlFor="items-per-page">Items per page: </label>
          <select
            id="items-per-page"
            value={productsPerPage}
            onChange={handleItemsPerPageChange}
          >
            <option value="4" style={{ fontFamily: "Raleway, serif" }}>4</option>
            <option value="8" style={{ fontFamily: "Raleway, serif" }}>8</option>
            <option value="12" style={{ fontFamily: "Raleway, serif" }}>12</option>
            <option value="16" style={{ fontFamily: "Raleway, serif" }}>16</option>
            <option value="20" style={{ fontFamily: "Raleway, serif" }}>20</option>
            <option value="24" style={{ fontFamily: "Raleway, serif" }}>24</option>
            <option value="28" style={{ fontFamily: "Raleway, serif" }}>28</option>
            <option value="32" style={{ fontFamily: "Raleway, serif" }}>32</option>
            <option value="36" style={{ fontFamily: "Raleway, serif" }}>36</option>
            <option value="40" style={{ fontFamily: "Raleway, serif" }}>40</option>
            <option value="44" style={{ fontFamily: "Raleway, serif" }}>44</option>
            <option value="48" style={{ fontFamily: "Raleway, serif" }}>48</option>
            <option value="52" style={{ fontFamily: "Raleway, serif" }}>52</option>
            <option value="100" style={{ fontFamily: "Raleway, serif" }}>100</option>

          </select>
        </div>
        <div className="pagination-controls">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Previous
          </button>
          <span className="page-number">{currentPage}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>


      </div>
      {/* <!-- pagination --> */}


      <div class="offcanvas offcanvas-end canvas-search" id="canvasSearch">
        <div class="canvas-wrapper">
          <header class="tf-search-head">
            <div class="title fw-5">
              Search our site
              <div class="close">
                <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
              </div>
            </div>
            <div class="tf-search-sticky">
              <form class="tf-mini-search-frm">
                <fieldset class="text">
                  <input type="text" placeholder="Search" class="" name="text" tabindex="0" value="" aria-required="true" required="" />
                </fieldset>
                <button class="" type="submit"><i class="icon-search"></i></button>
              </form>
            </div>
          </header>
          <div class="canvas-body p-0">

          </div>
        </div>
      </div>

      <div class="offcanvas offcanvas-start canvas-filter" id="filterShop">
        <div class="canvas-wrapper">
          <header class="canvas-header">
            <div class="filter-icon">

              <span>Filter</span>
            </div>
            <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" ><IoCloseSharp /></span>
          </header>
          <div class="canvas-body">
            <div class="tf-shop-sidebar wrap-sidebarmob">

              <div class="widget-facet ">
                <div
                  className="facet-title"
                  data-bs-target="#categories"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="categories"
                >
                  <span>Product categories</span>
                </div>

                <div id="categories" className="collapse show">

                  <ul className="space-y-2 mb-2">
                    {getCategoriesBasedOnStyle().map((category) => (
                      <li key={category._id} className="flex  gap-2">
                        <input
                          type="checkbox"
                          id={`category-${category._id}`}
                          checked={selectedCategories.includes(category.name)}
                          onChange={() => handleCategoryChange(category.name)}
                          className="hidden" // Hide checkbox
                        />
                        <label
                          htmlFor={`category-${category._id}`}
                          className="label-style"
                        >
                          {category.name}
                        </label>
                      </li>
                    ))}
                  </ul>

                </div>


              </div>
              <div className="widget-facet">
                <div
                  className="facet-title"
                  data-bs-target="#size"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="categories"
                >
                  <span>Size</span>
                </div>

                <div id='size' className="tf-pagination-list tf-pagination-btn collapse show">
                  <div className="tf-pagination-list tf-pagination-btn mb-2">
                    {Object.entries(sizes).map(([sizeLabel, sizeValue]) => (
                      <button
                        key={sizeLabel}
                        className={`pagination-link ${selectedSizes.includes(sizeValue)
                          ? 'text-success'
                          : 'animate-hover-btn'
                          }`}
                        onClick={() => {
                          setSelectedSizes(prev =>
                            prev.includes(sizeValue)
                              ? prev.filter(s => s !== sizeValue)
                              : [...prev, sizeValue]
                          );
                        }}
                      >
                        {sizeLabel}
                      </button>
                    ))}
                  </div>

                </div></div>

              <div className="widget-facet">
                <div
                  className="facet-title"
                  data-bs-target="#color"
                  data-bs-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="color"
                >
                  <span>Color</span>
                  <span className="icon icon-arrow-up"></span>
                </div>
                <div id="color" className="collapse show">
                  <div className="color-palette flex flex-wrap mb-2">
                    {colorOptions.map((color) => (
                      <div
                        key={color.value}
                        className={`color-box w-10 h-10 rounded-full cursor-pointer border ${selectedColors.includes(color.value)
                          ? "border-blue-500"
                          : "border-gray-300"
                          }`}
                        style={{ backgroundColor: color.hex }}
                        onClick={() => {
                          setSelectedColors((prev) =>
                            prev.includes(color.value)
                              ? prev.filter((c) => c !== color.value)
                              : [...prev, color.value]
                          );
                        }}
                      >
                        {selectedColors.includes(color.value) && (
                          <div className="flex items-center justify-center w-full h-full">
                            <Check className="w-4 h-4 text-white" />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div action="#" id="facet-filter-form" class="facet-filter-form">


                <div className="widget-facet wrap-price mb-8">
                  <div
                    className="facet-title"
                    data-bs-target="#price"
                    data-bs-toggle="collapse"
                    aria-expanded="true"
                    aria-controls="categories"
                  >
                    <span>Price Range</span>
                    <span className="icon icon-arrow-up"></span>
                  </div>


                  <div className="space-y-3 mb-6 collapse show mb-2" id="price" >
                    {priceRanges.map((range) => (
                      <label
                        key={range.label}
                        className="flex items-center p-2 hover:bg-gray-50 rounded-lg cursor-pointer"
                      >
                        <input
                          type="radio"

                          className="w-5 h-5 text-blue-600"
                          onChange={() => {
                            setSelectedPriceRange(range.label);
                            setMinPrice(range.min);
                            setMaxPrice(range.max);
                          }}
                          checked={selectedPriceRange === range.label} // React-managed checked state
                        />
                        <span className="ml-3 text-gray-700 " style={{ marginLeft: '10px' }}>{range.label}</span>
                      </label>
                    ))}
                  </div>


                </div>


                <div className="widget-facet">
                  <div
                    className="facet-title"
                    data-bs-target="#duration"
                    data-bs-toggle="collapse"
                    aria-expanded="true"
                    aria-controls="brand"
                  >
                    <span>Duration (Days)</span>
                    <span className="icon icon-arrow-up"></span>
                  </div>

                  <div className="tf-pagination-list tf-pagination-btn collapse show" id="duration">
                    {durations.map((day) => (
                      <button
                        key={day}
                        className={`pagination-link ${selectedDuration === day
                          ? 'text-success'
                          : 'animate-hover-btn'
                          }`}
                        onClick={() => handleDurationChange(day)}
                      >
                        {day}
                      </button>
                    ))}

                    <ul className="tf-filter-group current-scrollbar mb_36">
                      <label htmlFor="brand-1" className="label" style={{ marginTop: '10px' }}>
                        <span>Delivery On</span>
                      </label>
                      <li className="list-item d-flex gap-12 align-items-center " style={{ marginTop: '10px' }}>

                        <input
                          type="date"
                          name="brand"
                          className="tf-check"
                          style={{ width: '100%', height: '40px', fontFamily: "Raleway, serif" }}
                          id="brand-1"
                          value={deliveryDate}
                          onChange={(e) => handleDeliveryDateChange(e.target.value)}
                          min={new Date().toISOString().split('T')[0]}
                        />

                      </li>
                      <label htmlFor="brand-2" className="label" style={{ marginTop: '10px' }}>
                        <span>Return On</span>
                      </label>
                      <li className="list-item d-flex gap-12 align-items-center">

                        <input
                          type="date"
                          name="brand"
                          style={{ width: '100%', height: '40px', fontFamily: "Raleway, serif" }}
                          className="tf-check"
                          id="brand-2"
                          value={returnDate}
                          readOnly
                          min={deliveryDate || new Date().toISOString().split('T')[0]}
                        />

                      </li>
                    </ul>
                  </div>
                </div>

                <button
                  className="tf-btn w-100 radius-3 pbtn-bg animate-hover-btn justify-content-center"
                  onClick={handleApply}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="d-flex align-items-center gap-2 justify-content-center">
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      Please wait...
                    </span>
                  ) : (
                    'APPLY'
                  )}
                </button>

                <button
                  onClick={() => {
                    setSelectedCategories([]);
                    setSelectedSizes([]);
                    setSelectedColors([]);
                    setSelectedPriceRange('');
                    setSelectedDuration('');
                    setFilteredProducts(products);
                  }}
                  class="tf-btn w-100 radius-3 pbtn-bg animate-hover-btn justify-content-center mt-3"
                >
                  CLEAR ALL
                </button>



              </div>
            </div>

          </div>

        </div>

      </div>
      {/* </div> */}
      <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/">
            <div class="toolbar-icon">
              <IoHome />
            </div>
            <div class="toolbar-label">Home</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/products" >
            <div class="toolbar-icon">
              <BiCategoryAlt />
            </div>
            <div class="toolbar-label">Shop</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/SearchBar" >
            <div class="toolbar-icon">
              <IoSearchOutline />
            </div>
            <div class="toolbar-label">Search</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/cart">
            <div class="toolbar-icon">
              <FaShoppingCart />
            </div>
            <div class="toolbar-label">Cart</div>
          </a>
        </div>
      </div>
    </>
  )
}
export default Jodhpuri
